import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SrBadge.less';

export const SR_BADGE_THEME_PURPLE = 'purple';
export const SR_BADGE_THEME_GREY = 'grey';
export const SR_BADGE_THEME_ORANGE = 'orange';
export const SR_BADGE_THEME_BLUE = 'blue';
export const SR_BADGE_THEME_GREEN = 'green';
export const SR_BADGE_THEME_RED = 'red';

const SrBadge = ({ theme, icon, children }) => {
  return (
    <div styleName={classnames('SrBadge', theme)}>
      {icon}
      <span>{children}</span>
    </div>
  );
};

SrBadge.propTypes = {
  theme: PropTypes.oneOf([
    SR_BADGE_THEME_PURPLE,
    SR_BADGE_THEME_GREY,
    SR_BADGE_THEME_ORANGE,
    SR_BADGE_THEME_BLUE,
    SR_BADGE_THEME_GREEN,
    SR_BADGE_THEME_RED,
  ]).isRequired,
  icon: PropTypes.node,
  children: PropTypes.node.isRequired,
};

SrBadge.defaultProps = {
  icon: null,
};

SrBadge.displayName = 'SrBadge';

export default SrBadge;
